import { Fragment } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { setColumns } from 'app/store/ui/uiSlice';
// Selectors
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
import { selectColumns } from 'app/store/ui/uiSelectors';
// Mui
import { Theme, IconButton, ToggleButtonGroup, ToggleButton } from '@mui/material';
// Icons
import {
  ArrowDropDown as ArrowDropDownIcon
} from '@mui/icons-material';
// Components
import Icon, { IconVariants } from 'app/components/Icon';
import useMenu from 'app/hooks/useMenu';

const ColumnSwitcher = () => {
  const icons:IconVariants[] = ['columns_auto', 'columns_2', 'columns_3', 'columns_4'];
  // Dispach
  const dispatch = useAppDispatch();
  // State
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const columns = useAppSelector(selectColumns) as IconVariants;

  const { Menu, MenuItem, openMenu } = useMenu();

  const handleClick = (newColumnValue:IconVariants) => () => {
    console.log('newColumnValue', newColumnValue);
    dispatch(setColumns(newColumnValue));
  }

  if ( newDesignEnabled ) return (
    <Fragment>
      <IconButton
        name="Column switcher"
        sx={{
          border: (theme:Theme) => `1px solid ${theme.palette.divider}`,
          height: 40,
        }}
        onClick={openMenu}
      >
        <Icon icon={columns} />
        <ArrowDropDownIcon fontSize="small" />
      </IconButton>
      <Menu>
        {icons.map((icon:IconVariants) => {
          const [ columnLabel, columnType ] = icon.split('_');
          const label = columnType === 'auto' ? columnType : `${columnType} ${columnLabel}`;
          return (
            <MenuItem
              key={`column-switch-item-${icon}`}
              aria-label={`Switch ${label} button`}
              sx={{ gap: 2, textTransform: 'capitalize' }}
              name={label}
              onClick={handleClick(icon)}
              selected={columns === icon}
            >
              <Icon icon={icon} />
              {label}
            </MenuItem>
          )
        })}
      </Menu>
    </Fragment>
  )
  return (
    <Fragment>
      <ToggleButtonGroup
        value={columns}
        onChange={(_:any, newColumnValue) => handleClick(newColumnValue)()}
        size="small"
        color="primary"
        exclusive
      >
        {icons.map((icon:IconVariants) => (
          <ToggleButton
            key={`column-switch-item-${icon}`}
            aria-label={`Switch ${icon.split('_').join(' ')} button`}
            value={icon}
          ><Icon icon={icon} /></ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Fragment>
  )
}

export default ColumnSwitcher;